import Vue from 'vue'
import Router from 'vue-router'

const error404 = () => import('../pages/error-page/404')

const deptNavindex = () => import('../pages/deptNav/index')
const deptNavdetails = () => import('../pages/deptNav/details')

const index = () => import('../pages/index/index')
const applyindex = () => import('../pages/apply/index')
const applyprogress = () => import('../pages/apply/progress')
const applydoc = () => import('../pages/apply/doc')
const applynur = () => import('../pages/apply/nur')

const historyindex = () => import('../pages/history/index')

const graduationapplyHL = () => import('../pages/graduation/applyHL')
const graduationapplyYS = () => import('../pages/graduation/applyYS')

const payindex = () => import('../pages/pay/index')

const libraryindex = () => import('../pages/library/index')

const updateindex = () => import('../pages/update/index')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      name: 'error404',
      component: error404,
      meta: {
        title: '404',
      }
    },
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/deptNav/index',
      name: 'deptNavindex',
      component: deptNavindex,
    },
    {
      path: '/deptNav/details',
      name: 'deptNavdetails',
      component: deptNavdetails,
    },
    {
      path: '/apply/index',
      name: 'applyindex',
      component: applyindex,
    },
    {
      path: '/apply/progress',
      name: 'applyprogress',
      component: applyprogress,
    },
    {
      path: '/apply/doc',
      name: 'applydoc',
      component: applydoc,
    },
    {
      path: '/apply/nur',
      name: 'applynur',
      component: applynur,
    },
    {
      path: '/history/index',
      name: 'historyindex',
      component: historyindex,
    },
    {
      path: '/graduation/applyHL',
      name: 'graduationapplyHL',
      component: graduationapplyHL,
    },
    {
      path: '/graduation/applyYS',
      name: 'graduationapplyYS',
      component: graduationapplyYS,
    },
    {
      path: '/pay/index',
      name: 'payindex',
      component: payindex,
    },
    {
      path: '/library/index',
      name: 'libraryindex',
      component: libraryindex,
    },
    {
      path: '/update/index',
      name: 'updateindex',
      component: updateindex,
    },
  ],
  mode:"history",
})

// 捕获路由懒加载chunk错误
let hasReload = false // 防抖标记，防止反复刷新
router.onError((error) => {
  const pattern = /Loading chunk (\S)+ failed|ChunkLoadError/g
  const isChunkLoadFailed = pattern.test(error.message)
  if (isChunkLoadFailed && !hasReload) {
    hasReload = true
    if (confirm('系统已经更新，点击确定刷新页面加载新版本')) {
      window.location.reload()
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js